import React from 'react';
import classNames from 'classnames/bind';
import styles from './PollBar.scss';

const cx = classNames.bind(styles);

// const propTypes = {
//   percent: React.PropTypes.number.isRequired,
//   title: React.PropTypes.string.isRequired,
//   className: React.PropTypes.string,
//   certColor: React.PropTypes.number,
// };

const defaultProps = {
};

const PollBar = ({ title, percent, className, certColor }) =>
  <div className={cx({ root: true }, className)}>
    <div className={cx({ bar: true, [`color${certColor}`]: !!certColor })}>
      <div
        className={cx({ fill: true, [`color${certColor}`]: !!certColor })}
        style={{ width: `${percent}%` }}
      />
    </div>
    <div className={styles.title}>{title}</div>
  </div>;

// PollBar.propTypes = propTypes;
PollBar.defaultProps = defaultProps;


export default PollBar;
